import { useEffect, useRef } from "react";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

/**
 * Renders the official Google Sign-In button.
 * onCredential(credential) is called with the Google ID token.
 */
export default function GoogleButton({ onCredential, text = "continue_with" }) {
  const divRef = useRef(null);

  useEffect(() => {
    if (!CLIENT_ID || !divRef.current) return;

    const render = () => {
      if (!window.google?.accounts?.id || !divRef.current) return;
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: (resp) => resp?.credential && onCredential(resp.credential),
      });
      window.google.accounts.id.renderButton(divRef.current, {
        theme: "outline",
        size: "large",
        width: 320,
        text,
        locale: "tr",
      });
    };

    if (window.google?.accounts?.id) {
      render();
      return;
    }
    const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
    if (existing) {
      existing.addEventListener("load", render);
      return () => existing.removeEventListener("load", render);
    }
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true;
    s.onload = render;
    document.head.appendChild(s);
  }, [onCredential, text]);

  if (!CLIENT_ID) return null;
  return <div ref={divRef} className="flex justify-center" />;
}
